interface eventInterface {
  message: string;
  type: string;
}

class EventBus {
  private eventTarget = new EventTarget(); // This is where the event will be fired

  emit(eventName: string, detail?: eventInterface) {
    //JavaScript evaluates function arguments first, from left to right, before actually calling the function.
    //new CustomEvent(eventName, { detail }) is created first.
    //That instance is then passed to dispatchEvent().
    //Finally, dispatchEvent() triggers the event on eventTarget.
    //--------
    //Creating the Event: The event is created using new CustomEvent(eventName, { detail }). This is the event itself that you want to dispatch.
    //Dispatching the Event: The event is dispatched using eventTarget.dispatchEvent(eventInstance).
    //When you call dispatchEvent(), the event is fired on the eventTarget object.
    //dispatchEvent() tells the target (in your case, eventTarget) to notify all the listeners that have been registered for the event name (like myEvent).
    //Event Listeners on eventTarget: Any listeners added to eventTarget using addEventListener() will be triggered when dispatchEvent() is called.
    this.eventTarget.dispatchEvent(new CustomEvent(eventName, { detail })); // dispatchEvent= Manually triggers an event on the target.
    //Calling dispatchEvent() is the last step to firing an event.
  }

  on(eventName: string, callback: (event: CustomEvent) => void) {
    const listener = (event: Event) => callback(event as CustomEvent);
    this.eventTarget.addEventListener(eventName, listener);
    return () => this.eventTarget.removeEventListener(eventName, listener);
  }
}

export const eventBus = new EventBus();
